import React, { Component, Fragment } from 'react';
import { Redirect, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { LoadingSpinnerSVG, Logo, LanguagePicker } from 'cx-ui-components';
import { FormattedMessage, injectIntl } from 'react-intl';
import { mappedLocalesOptions } from '../../i18n';
import { cxInit, versionCheck } from '../../utils/cxSdk';
import { cxResetPassword } from '../../utils/cxSdk';
import { Toast } from 'cx-ui-components';
import { validateEmail } from 'serenova-js-utils/validation';

import PrivacyPolicy from '../Legal/privacyPolicy';
import LegalPolicy from '../Legal/legalPolicy';
import messages from './messages';

const Loading = styled(LoadingSpinnerSVG)`
  top: 150px;
  top: calc(50% - ${(props) => props.size / 2}px);
  left: calc(50% - ${(props) => props.size / 2}px);
`;

const TempBackground = styled.div`
  position: fixed;
  top: 0px;
  width: 100%;
  height: 100%;
  background-repeat: repeat;
  background-image: url('https://qe-config.cxengagelabs.net/assets/images/square_bg.png'),
    linear-gradient(to bottom, #0a64aa, #3498db);
  z-index: -1;
`;

const SignInTitle = styled.div`
  font-size: 20px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  color: rgb(73, 73, 73);
  display: block;
  text-align: center;
  margin: 30px 0px;
`;

const LoginFormWrapper = styled.div`
  position: relative;
  top: 70px;
`;

const LoginBox = styled.div`
  width: 540px;
  height: 560px;
  margin: 0px auto;
  margin-top: calc(50vh - 270px);
  border-radius: 3px;
  background-color: rgb(255, 255, 255);
  box-shadow: rgba(0, 0, 0, 0.09) 0px 0px 6px 0px;
  position: relative;
  z-index: 1;
`;

const EmailInput = styled.input`
  width: 282px;
  height: 44px;
  background-color: rgb(255, 255, 255);
  font-size: 16px;
  font-style: normal;
  font-stretch: normal;
  color: rgb(73, 73, 73);
  outline: none;
  padding: 0px 11px;
  border-radius: 2px;
  border-width: 1px;
  border-style: solid;
  border-color: rgb(151, 151, 151);
  margin-bottom: 10px;
  display: block;
  margin: 10px auto;
`;

const ResetButton = styled.button`
  border-radius: 8px;
  border-width: 0px;
  background-color: rgb(35, 205, 244);
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  color: rgb(255, 255, 255);
  padding: 14px 28px;
  cursor: pointer;
  outline: none;
  display: block;
  margin: 10px auto;
`;

const StyledLanguagePicker = styled(LanguagePicker)`
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 1.5em;
`;

const BackToLogin = styled.div`
  text-align: center;
`;

const storage = window.localStorage;

export class ForgotPassword extends Component {
  constructor() {
    super();
    this.state = {
      username: '',
      redirect: false
    };
  }

  resetPassword = () => {
    if (validateEmail(this.state.username)) {
      cxResetPassword(this.state.username);
      this.setState({ redirect: true });
    } else {
      Toast.error(this.props.intl.formatMessage(messages.invalidEmail));
    }
  };

  setUsername = (e) => {
    this.setState({
      username: e.target.value,
    });
  };

  onEnterKey = ({ key }) => (key === 'Enter' ? this.resetPassword() : undefined);

  changeLocale = (locale) => {
    storage.setItem('locale', locale);
    this.props.changeLocale(locale);
  };

  render() {
    if (!this.props.insideIframe && !this.props.hasStarted) {
      return (
        <Fragment>
          {this.state.redirect==true? <Redirect to="/" />:null }
          <LoginBox>
            <LoginFormWrapper>
              <Logo />
              <div>
                <SignInTitle>
                  <FormattedMessage {...messages.welcome}/>
                </SignInTitle>
                <EmailInput
                  data-automation="email"
                  placeholder={this.props.intl.formatMessage(messages.email)}
                  type="email"
                  onChange={this.setUsername}
                  value={this.state.username}
                />
                <ResetButton data-automation="resetButton" onClick={() => this.resetPassword()}>
                  <FormattedMessage {...messages.resetButton} />
                </ResetButton>
                <BackToLogin>
                  <Link to="/" data-automation="backToLogin">
                    <FormattedMessage {...messages.backToLogin}/>
                  </Link>
                </BackToLogin>
              </div>
            </LoginFormWrapper>
          </LoginBox>
          {location.hash.includes('alpha') && (
            <StyledLanguagePicker
              color="#fff"
              onLanguageChange={this.changeLocale}
              selectedLocale={this.props.locale}
              languageOptions={mappedLocalesOptions}
            />
          )}
          <LegalPolicy />
          <PrivacyPolicy />
          <TempBackground />
        </Fragment>
      );
    } else if (!this.props.insideIframe && this.props.hasStarted) {
      return <Redirect to="/configuration/users" />;
    } else {
      return <Loading size={120} />;
    }
  }
}

export default injectIntl(ForgotPassword);

ForgotPassword.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  setUserAuthed: PropTypes.func.isRequired,
  fetchBranding: PropTypes.func.isRequired,
  updateUserPermissions: PropTypes.func.isRequired,
  hasStarted: PropTypes.bool.isRequired,
  children: PropTypes.any,
  insideIframe: PropTypes.bool.isRequired,
  updatePlatformPermissions: PropTypes.func,
  locale: PropTypes.string.isRequired,
  intl: PropTypes.object.isRequired,
  changeLocale: PropTypes.func.isRequired,
};
